export const destroyProductFruit = () =>
  window.productFruits?.services?.destroy?.();
